var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_3017)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 3C0.75 3.29547 0.808198 3.58806 0.921271 3.86104C1.03434 4.13402 1.20008 4.38206 1.40901 4.59099C1.61794 4.79992 1.86598 4.96566 2.13896 5.07873C2.41194 5.1918 2.70453 5.25 3 5.25C3.29547 5.25 3.58806 5.1918 3.86104 5.07873C4.13402 4.96566 4.38206 4.79992 4.59099 4.59099C4.79992 4.38206 4.96566 4.13402 5.07873 3.86104C5.1918 3.58806 5.25 3.29547 5.25 3C5.25 2.70453 5.1918 2.41194 5.07873 2.13896C4.96566 1.86598 4.79992 1.61794 4.59099 1.40901C4.38206 1.20008 4.13402 1.03434 3.86104 0.921271C3.58806 0.808198 3.29547 0.75 3 0.75C2.70453 0.75 2.41194 0.808198 2.13896 0.921271C1.86598 1.03434 1.61794 1.20008 1.40901 1.40901C1.20008 1.61794 1.03434 1.86598 0.921271 2.13896C0.808198 2.41194 0.75 2.70453 0.75 3Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 21C0.75 21.2955 0.808198 21.5881 0.921271 21.861C1.03434 22.134 1.20008 22.3821 1.40901 22.591C1.61794 22.7999 1.86598 22.9657 2.13896 23.0787C2.41194 23.1918 2.70453 23.25 3 23.25C3.29547 23.25 3.58806 23.1918 3.86104 23.0787C4.13402 22.9657 4.38206 22.7999 4.59099 22.591C4.79992 22.3821 4.96566 22.134 5.07873 21.861C5.1918 21.5881 5.25 21.2955 5.25 21C5.25 20.7045 5.1918 20.4119 5.07873 20.139C4.96566 19.866 4.79992 19.6179 4.59099 19.409C4.38206 19.2001 4.13402 19.0343 3.86104 18.9213C3.58806 18.8082 3.29547 18.75 3 18.75C2.70453 18.75 2.41194 18.8082 2.13896 18.9213C1.86598 19.0343 1.61794 19.2001 1.40901 19.409C1.20008 19.6179 1.03434 19.866 0.921271 20.139C0.808198 20.4119 0.75 20.7045 0.75 21Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3C18.75 3.59674 18.9871 4.16903 19.409 4.59099C19.831 5.01295 20.4033 5.25 21 5.25C21.5967 5.25 22.169 5.01295 22.591 4.59099C23.0129 4.16903 23.25 3.59674 23.25 3C23.25 2.40326 23.0129 1.83097 22.591 1.40901C22.169 0.987053 21.5967 0.75 21 0.75C20.4033 0.75 19.831 0.987053 19.409 1.40901C18.9871 1.83097 18.75 2.40326 18.75 3Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 21C18.75 21.5967 18.9871 22.169 19.409 22.591C19.831 23.0129 20.4033 23.25 21 23.25C21.5967 23.25 22.169 23.0129 22.591 22.591C23.0129 22.169 23.25 21.5967 23.25 21C23.25 20.4033 23.0129 19.831 22.591 19.409C22.169 18.9871 21.5967 18.75 21 18.75C20.4033 18.75 19.831 18.9871 19.409 19.409C18.9871 19.831 18.75 20.4033 18.75 21Z",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 2L19 2",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 19L22 5",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 22L19 22",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 5L2 19",
    stroke: "#023859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_3017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/Square.fb22e19414d9ca764866ba7ac6a8f21c.svg";
export { ForwardRef as ReactComponent };